export interface AuthState {
  token: string | null;
  refreshToken: string | null;
  email: string | null;
  existing_user: boolean | null;
  company: string | null;
  forgotPasswordSuccess: boolean | null;
  error: string | null;
  /**
   * Set true after successful partner-qualifying sign-up
   */
  pendingPartnerSubscriptionOfferAfterSignUp: boolean;
}

export const initialState: AuthState = {
  token: null,
  refreshToken: null,
  email: null,
  existing_user: null,
  company: null,
  forgotPasswordSuccess: null,
  error: null,
  pendingPartnerSubscriptionOfferAfterSignUp: false,
};
